<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ '$notes$' | translate }}</h5>
    <button type="button" class="close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pt-3">
    <div class="form-group">
      <label for="notetitle">{{ '$field_Title$' | translate }}</label>
      <p>{{ rolodexNote?.title || ('$not_available$' | translate) }}</p>
    </div>
    <div class="form-group">
      <label for="notes">{{ '$note_description_label$' | translate }}</label>
      <p name="notes" [innerHTML]="rolodexNote?.description || ('$not_available$' | translate)"></p>
    </div>
  </div>
  <div class="modal-footer text-left justify-content-between">
    <div class="form-group buttons mt-2">
      <div class="row">
        <div class="col-12 col-sm-6">
          <button type="button" class="btn btn-secondary btn-capsule" (click)="modal.dismiss()">
            <span class="pr-0">{{ '$cancel$' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
